import React, { Component } from 'react'
import {CardHeader} from 'reactstrap'
import ManualPrint from './ManualPrint'

class MainManual extends Component {

  render() {
    return (
      <div className="manual">
        <CardHeader><b>Manual</b></CardHeader>
        <ManualPrint />
      </div>
    )
  }
}
export default MainManual



// WEBPACK FOOTER //
// ./src/components/Manual/MainManual.js